import React, {useEffect, useState} from 'react';
import styles from './ClientProjectNote.module.css';
import {projectNoteAPI, projectNoteImageAPI} from '../../../services/client';
import {ProjectNoteResponseData} from '../../../types/client';
import logo from '../../../assets/covi_logo_white.png';

interface ClientProjectNoteProps {
    projectId: number;
}

// 프로젝트 특이사항, 어드민이 공개한 경우에만 조회 가능
const ClientProjectNote: React.FC<ClientProjectNoteProps> = ({projectId}) => {
    const [data, setData] = useState<ProjectNoteResponseData | null>(null);
    const [image, setImage] = React.useState<string>();
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        try {
            setLoading(true);
            //프로젝트 특이사항 조회 API
            const response = await projectNoteAPI(projectId);
            setData(response);
            //프로젝트 특이사항 샘플 데이터 조회 API
            const file = await projectNoteImageAPI(projectId);
            //파일 내부 URL 생성
            const url = URL.createObjectURL(file);
            setImage(url);
        } catch (error) {
            console.error('Error fetching project note:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [projectId]);

    if (loading) {
        return <div className={styles.loading}>Loading...</div>;
    }

    return (
        <div className={styles.noteContainer}>
            <h2 className={styles.title}>Project Note</h2>
            <p className={styles.subtitle}>프로젝트 특이사항</p>

            <div className={styles.content}>
                <div className={styles.left}>
                    <div className={styles.imageContainer}>
                        {/*프로젝트 특이사항 샘플 데이터*/}
                        {image ? (
                            <img
                                src={image}
                                alt="Project Note Sample"
                                className={styles.noteImage}
                                onError={(e) => {
                                    e.currentTarget.src = logo;
                                }}
                            />
                        ) : (
                            <div className={styles.noImage}>No note image available</div>
                        )}
                    </div>
                    <div className={styles.noteTitle}>
                        {/*프로젝트명*/}
                        <h3>{data?.projectName || 'Project'}</h3>
                    </div>
                </div>

                <div className={styles.noteContent}>
                    {/*프로젝트 특이사항*/}
                    {data?.noteContent ? (
                        <p className={styles.noteText}>{data.noteContent}</p>
                    ) : (
                        <div className={styles.noNote}>No note available</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ClientProjectNote;